import * as React from 'react';

import {Dropdown, DropdownItem} from '@homeaway/react-dropdown';
import {SVGIcon} from '@homeaway/react-svg';
import {CARET_DOWN__16} from '@homeaway/svg-defs/lib/defs/CARET_DOWN__16';
import {MAIL__16} from '@homeaway/svg-defs/lib/defs/MAIL__16';
import {HEART__16} from '@homeaway/svg-defs/lib/defs/HEART__16';
import {SUITCASE__16} from '@homeaway/svg-defs/lib/defs/SUITCASE__16';
import {PERSON__16} from '@homeaway/svg-defs/lib/defs/PERSON__16';
import {GEAR__16} from '@homeaway/svg-defs/lib/defs/GEAR__16';
import {DASHBOARD__16} from '@homeaway/svg-defs/lib/defs/DASHBOARD__16';
import {LOG_OUT__16} from '@homeaway/svg-defs/lib/defs/LOG_OUT__16';

const travelerRE = /service=(\w+\%3A\%2F\%2F[\.\w]+).*/;

const TRAVELER_SVGS = {
    'inbox': MAIL__16,
    'heart': HEART__16,
    'suitcase': SUITCASE__16,
    'user': PERSON__16,
    'settings': GEAR__16,
    'dashboard': DASHBOARD__16,
    'door': LOG_OUT__16
};

export class Traveler extends React.Component {
    createClickHandler = (item) => {
        return (event) => {
            if (!item.link) {
                return false;
            }

            // skip sub URL logic as link has already been manually updated
            if (item.linkUpdated) {
                return true;
            }

            // CAS Logout URLs need to be single enocded because of how their params are structured:
            // https://{DOMAIN}/haod/auth/signout.html?service={SINGLE_ENCODED_RETURN_URL}
            let singleEncodedURI = encodeURIComponent(window.location.pathname + window.location.search);

            // if traveler logged in, perform specific link update
            const newLink = item.link.replace(
                travelerRE,
                `service=$1${singleEncodedURI}`
            );

            // if we generate a new link, user has navigated to a sub URL in the same application
            // and we should redirect them there.  Otherwise let default user-agent behavior handle
            // rendered link
            if (newLink !== item.link) {
                event.stopPropagation();
                event.preventDefault();
                window.location.assign(newLink);
            }

            return true;
        };
    }


    renderItem = (item, index) => {
        if (item.cssClass === 'divider') {
            return (
                <DropdownItem className="divider" key={index} />
            );
        }

        return (
            <DropdownItem
                dataBypass
                key={index}
                link={item.link}
                onClick={this.createClickHandler(item)}
                svgMarkup={TRAVELER_SVGS[item.icon]}
                text={item.text}
            />
        );
    }

    render() {
        if (!this.props.items) {
            return null;
        }

        let id = 'site-header__traveler';

        const toggle = (
            <button
                aria-expanded="false"
                aria-haspopup="true"
                className="site-header-nav__toggle Dropdown__toggle"
                id={id}
            >
                <img
                    alt="avatar"
                    aria-hidden="true"
                    className="site-header-nav__avatar img-circle"
                    src={this.props.avatar.image}
                />
                {this.props.label} <SVGIcon className="Dropdown__toggle-icon Dropdown__toggle-icon--header" inlineFlex markup={CARET_DOWN__16}/>
            </button>
        );

        return (
            <Dropdown
                className="site-header-nav__dropdown"
                customToggle={toggle}
                dropdownRight
                id={id}
                label={this.props.label}
            >
                {this.props.items.map(this.renderItem)}
            </Dropdown>
        );
    }
}
